// @flow
import I18n from '../i18n';
import { formatValue } from './';

export const rawValueToNumberOrUnlimited = (rawValue: string): number | string => {
  if (!rawValue) {
    return 0;
  }

  if (rawValue === 'UNL') {
    return rawValue;
  }

  return parseInt(rawValue, 10);
};

const getPlanShortTextForType = (value: number | string, type: string): string => {
  const valueFormatted = formatValue(value, type);
  let planShortText = valueFormatted;

  if (value === 'UNL') {
    planShortText = I18n.t(`Dashboard.Plan.unlimitedShortValue.${type}`);
  }

  return planShortText;
};

export const getPlanFirstItem = (rawData: string, rawVoice: string, rawSms: string): string => {
  const data = rawValueToNumberOrUnlimited(rawData);
  const voice = rawValueToNumberOrUnlimited(rawVoice);
  const sms = rawValueToNumberOrUnlimited(rawSms);

  if (!!data && data !== 0) return getPlanShortTextForType(data, 'VOLUME');
  if (!!voice && voice !== 0) return getPlanShortTextForType(voice, 'DURATION');
  if (!!sms && sms !== 0) return getPlanShortTextForType(sms, 'SMS');
  return '';
};

export const getPlanSecondItem = (rawData: string, rawVoice: string, rawSms: string): string => {
  const data = rawValueToNumberOrUnlimited(rawData);
  const voice = rawValueToNumberOrUnlimited(rawVoice);
  const sms = rawValueToNumberOrUnlimited(rawSms);
  if (voice !== 0 && data !== 0) return `& ${getPlanShortTextForType(voice, 'DURATION')}`;
  if (sms !== 0 && voice !== 0 && data === 0) return `& ${getPlanShortTextForType(sms, 'SMS')}`;
  if (sms !== 0 && data !== 0 && voice === 0) return `& ${getPlanShortTextForType(sms, 'SMS')}`;
  return '';
};


const addRoamingItem = (items: string[], rawValue: string, type: string) => {
  const value = rawValueToNumberOrUnlimited(rawValue);
  if (value !== 0) {
    const planShortText = getPlanShortTextForType(value, type);
    items.push(planShortText);
  }
};

export const getPlanRoamingItem = (rawData: string, rawVoice: string): string => {
  const roamingItems = [];

  addRoamingItem(roamingItems, rawData, 'VOLUME');
  addRoamingItem(roamingItems, rawVoice, 'DURATION');

  return roamingItems.join(' & ');
};
